var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/ModelRepo/BimFile.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { createPredicate } from '../createPredicate';
import { Id } from '../Id';
import { ApiDomain } from '../domain';
import { ModelErrorCodeType } from '../ModelErrorCodeType';
import { Urn } from '../Urn';
export var BimFile;

(function (_BimFile) {
  var domain = ApiDomain.domain('BimFile', {
    name: "domain",
    sid: "-oyulh4"
  }); // FSK-603 в ModelRepository мы получаем сущность с типом ModelRepositoryBimFile,
  // в  api.BimModel.fetchLatestBimFile мы получаем сущность с типом BimFile

  var type = _BimFile.type = t.union([t.literal('ModelRepositoryBimFile'), t.literal('BimFile')]);
  var ModelRepositoryBimFileType = _BimFile.ModelRepositoryBimFileType = 'ModelRepositoryBimFile';
  var BimFileType = _BimFile.BimFileType = 'BimFile';
  var Status;

  (function (_Status) {
    var io = _Status.io = t.union([t.literal('NotImported'), t.literal('ImportInProgress'), t.literal('ImportCompleted'), t.literal('ImportError')], 'BimFileStatus');
    var NotImported = _Status.NotImported = t.literal('NotImported', 'BimFileStatusNotImported');
    var ImportInProgress = _Status.ImportInProgress = t.literal('ImportInProgress', 'BimFileStatusImportInProgress');
    var ImportCompleted = _Status.ImportCompleted = t.literal('ImportCompleted', 'BimFileStatusImportCompleted');
    var ImportError = _Status.ImportError = t.literal('ImportError', 'BimFileStatusImportError');
  })(Status || (Status = _BimFile.Status || (_BimFile.Status = {})));

  var ioBuilder = _BimFile.ioBuilder = function (type) {
    return t.type({
      type: type,
      urn: Urn,
      projectUrn: Urn,
      versionId: t.number,
      versionName: t.number,
      author: t.union([t.string, t["null"]]),
      uploadDate: t.string,
      status: Status.io,
      name: t.string,
      baseClassifierId: t.union([Id, t["null"]]),
      baseClassifierVersion: t.union([t.number, t["null"]]),
      errorCode: t.union([t.undefined, t["null"], ModelErrorCodeType])
    });
  };

  var io = _BimFile.io = t.type({
    type: type,
    urn: Urn,
    projectUrn: Urn,
    versionId: t.number,
    versionName: t.number,
    author: t.union([t.string, t["null"]]),
    uploadDate: t.string,
    status: Status.io,
    name: t.string,
    baseClassifierId: t.union([Id, t["null"]]),
    baseClassifierVersion: t.union([t.number, t["null"]]),
    errorCode: t.union([t.undefined, t["null"], ModelErrorCodeType])
  });
  var isBimFile = _BimFile.isBimFile = createPredicate(BimFileType);
  var isModelRepositoryBimFile = _BimFile.isModelRepositoryBimFile = createPredicate(ModelRepositoryBimFileType);
  var Import = _BimFile.Import = ApiCallService.create({
    name: 'import',
    parentDomain: domain,
    result: BimFile.io,
    getKey: ['bimFileUrn', 'bimFileVersion', 'projectUrn']
  });
})(BimFile || (BimFile = {}));